import { useParams } from 'react-router-dom';
import useViewPublicRealPlayQuery from 'features/publicRoleplay/services/queries/useViewPublicRoleplay';
import PublicRealPlayHelper from 'features/publicRoleplay/publicRealPlay.helper';

const RedirectPageLogic = () => {
  const { token } = useParams();
  const { isLoading } = useViewPublicRealPlayQuery({ token });
  const { showResults } = PublicRealPlayHelper();

  return { token, isLoading, showResults };
};

export default RedirectPageLogic;
